/* Stienhardt Journey Pixel — theme tag v1 (2026-07-29)
 * First-party journey tracking. Replaces Microsoft Clarity's event role.
 * Deploy to DEV theme first. Kill switch: window.SPJ_DISABLED = true.
 * Transport: fetch keepalive + Authorization header (collector requires it).
 */
(function () {
  'use strict';
  if (window.SPJ_DISABLED || window.__spjLoaded) return;
  window.__spjLoaded = true;

  // ---------- config ----------
  var ENDPOINT = 'https://zkvdtxlhzucquktwyrjw.supabase.co/functions/v1/collect';
  var AUTH = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InprdmR0eGxoenVjcXVrdHd5cmp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMzcwODMsImV4cCI6MjEwMDkxMzA4M30.T6p6Z4_URBOQHm8kLZXEhVUEf_xAZUk2_t7HpYI1shg';
  var WRITE_KEY = 'sjp_wk_9f27c1e84ab35d60';
  var FLUSH_N = 12, FLUSH_MS = 3000;

  // ---------- consent ----------
  function consentOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() !== false;
      }
    } catch (e) {}
    return true; // no consent API present -> default allowed (matches current Clarity behavior)
  }

  // ---------- ids ----------
  function cookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g, function () {
      return (Math.random() * 16 | 0).toString(16);
    });
  }
  var visitor = cookie('_shopify_y') || (function () {
    try {
      var v = localStorage.getItem('spj_vid');
      if (!v) { v = 'spj_' + uuid(); localStorage.setItem('spj_vid', v); }
      return v;
    } catch (e) { return 'spj_' + uuid(); }
  })();

  var SS = window.sessionStorage;
  function newSession() {
    var s = 's_' + Date.now().toString(36) + '_' + uuid().slice(0, 8);
    try { SS.setItem('spj_sid', s); SS.setItem('spj_day', new Date().toDateString()); } catch (e) {}
    return s;
  }
  var session = (function () {
    try {
      var s = SS.getItem('spj_sid'), last = +SS.getItem('spj_last') || 0;
      var sameDay = SS.getItem('spj_day') === new Date().toDateString();
      if (s && sameDay && Date.now() - last < 30 * 60 * 1000) return s;
    } catch (e) {}
    return newSession();
  })();
  function touch() { try { SS.setItem('spj_last', String(Date.now())); } catch (e) {} }
  touch();

  // ---------- attribution (captured once per session) ----------
  var Q = {};
  try {
    location.search.slice(1).split('&').forEach(function (p) {
      var kv = p.split('='); if (kv[0]) Q[kv[0].toLowerCase()] = decodeURIComponent(kv[1] || '');
    });
  } catch (e) {}
  var attr = null;
  try { attr = JSON.parse(SS.getItem('spj_attr') || 'null'); } catch (e) {}
  var clickId = Q.gclid ? 'g:' + Q.gclid : Q.ttclid ? 't:' + Q.ttclid : Q.fbclid ? 'f:' + Q.fbclid : Q._kx ? 'kx:' + Q._kx : null;
  var refHost = '';
  try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
  var internalNav = refHost === location.hostname;
  if (internalNav) refHost = '';
  // capture attribution only on ARRIVAL — internal links carrying utm params
  // (homepage hero banners etc.) must not overwrite the session's true source
  if (!attr || ((Q.utm_source || clickId) && !internalNav)) {
    attr = {
      us: (!internalNav && Q.utm_source) || null,
      um: (!internalNav && Q.utm_medium) || null,
      uc: (!internalNav && Q.utm_campaign) || null,
      cid: clickId, ref: refHost || null, land: location.pathname
    };
    // in-app webviews hide the referrer but betray themselves in the UA —
    // recover TikTok/IG/FB traffic that would otherwise land in "direct"
    if (!attr.us && !attr.cid && !attr.ref) {
      var ua = navigator.userAgent;
      var app = /musical_ly|Bytedance|TTWebView/i.test(ua) ? 'tiktok'
        : /Instagram/i.test(ua) ? 'instagram'
        : /FBAN|FBAV|FB_IAB/i.test(ua) ? 'facebook'
        : /Pinterest/i.test(ua) ? 'pinterest' : null;
      if (app) { attr.us = app; attr.um = app + '-app'; }
    }
    try { SS.setItem('spj_attr', JSON.stringify(attr)); } catch (e) {}
  }

  // ---------- page type classifier (mirrors the 14-room map) ----------
  var TRUST = /^\/pages\/(shipping|free-shipping|international-shipping|return-policy|free-returns|free-resizing|manufacturing-warranty|easy-financing|customer-reviews|about-us|contact-us|book-an-appointment|ethical-diamonds|faqs|privacy-policy|terms-conditions|diamond-upgrade)/;
  var SETTING_COLL = /engagement|solitaire$|halo|vintage|three-stone|side-stone|pave|hidden-halo|-cut-diamond-engagement|preset|trending-engagement|ready-to-ship-engagement|heritage|old-mine|old-european/;
  var DIAMOND_COLL = /lab-grown-diamonds$|-carat-lab-grown|fancy-color-diamonds/;
  function pageType() {
    var p = location.pathname.replace(/\/$/, '') || '/';
    if (p === '/') return 'home';
    if (p === '/cart') return 'cart';
    if (p === '/collections/lab-diamonds') return 'diamond_search';
    if (p === '/products/diamonds') return 'diamond_pdp';
    // v3.1: nested product URLs (/collections/x/products/y) are PRODUCT pages,
    // not collections — this mislabel hid setting-page views for weeks. Minted
    // diamond products are detected via Shopify's product meta, not DOM.
    if (/^\/products\//.test(p) || /^\/collections\/[^\/]+\/products\//.test(p)) {
      if (/\/products\/diamonds$/.test(p)) return 'diamond_pdp';
      if (/view=final-ring/.test(location.search)) return 'final_ring';
      try {
        var mp = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
        if (mp && String(mp.type).trim().toLowerCase() === 'diamond') return 'diamond_pdp';
      } catch (e0) {}
      var hnd = (p.split('/products/')[1] || '').toLowerCase();
      if (/setting/.test(hnd) || document.getElementById('choosethissetting')) return 'setting_pdp';
      return 'jewelry_pdp';
    }
    if (/^\/collections\//.test(p)) {
      var h = p.split('/')[2] || '';
      if (DIAMOND_COLL.test(h)) return 'collection_diamond';
      if (SETTING_COLL.test(h)) return 'collection_setting';
      return 'collection_jewelry';
    }
    if (/^\/pages\/.*-landing$/.test(p)) return 'lander';
    if (p === '/pages/search') return 'search';
    if (p === '/pages/wishlist') return 'wishlist';
    if (TRUST.test(p)) return 'trust';
    if (/^\/(blogs|pages)\//.test(p)) return 'content';
    return 'page';
  }
  var PT = pageType();

  // ---------- device ----------
  var UA = navigator.userAgent;
  var device = /Mobi|Android/i.test(UA) ? (Math.min(screen.width, screen.height) > 500 ? 'tablet' : 'mobile') : 'desktop';
  var os = /iPhone|iPad|iPod/.test(UA) ? 'iOS' : /Android/.test(UA) ? 'Android' : /Windows/.test(UA) ? 'Windows' : /Mac/.test(UA) ? 'macOS' : 'other';
  var browser = /CriOS|Chrome/.test(UA) ? 'Chrome' : /FxiOS|Firefox/.test(UA) ? 'Firefox' : /Safari/.test(UA) ? 'Safari' : 'other';

  // ---------- transport ----------
  var buf = [], timer = null;
  function base(name) {
    return {
      event_id: uuid(), ts: Date.now(), visitor_id: visitor, session_id: session,
      name: name, source: 'theme',
      page_type: PT, page_path: location.pathname, page_title: (document.title || '').slice(0, 200),
      utm_source: attr.us, utm_medium: attr.um, utm_campaign: attr.uc,
      click_id: attr.cid, referrer_host: attr.ref, landing_path: attr.land,
      device: device, os: os, browser: browser,
      vw: window.innerWidth, vh: window.innerHeight,
      consent: consentOk() ? 'granted' : 'denied'
    };
  }
  function flush() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (!buf.length) return;
    var events = buf.splice(0, 50);
    try {
      fetch(ENDPOINT, {
        method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/json', 'Authorization': AUTH },
        body: JSON.stringify({ k: WRITE_KEY, events: events })
      }).catch(function () {});
    } catch (e) {}
  }
  function ev(name, extra) {
    if (window.SPJ_DISABLED || !consentOk()) return;
    var e = base(name);
    if (extra) for (var k in extra) if (extra[k] != null) e[k] = extra[k];
    buf.push(e); touch();
    if (buf.length >= FLUSH_N) flush();
    else if (!timer) timer = setTimeout(flush, FLUSH_MS);
  }

  /* diamond-guided-choices-v1-canary: first-party telemetry */
  function sdTrackGuidedCanary(row) {
    if (!row || row.experiment !== 'diamond-guided-choices-v1-canary') return;
    var allowedGroups = { treatment: 1, control: 1 };
    var allowedStages = { eligible: 1, exposed: 1, click: 1 };
    if (!allowedGroups[row.group] || !allowedStages[row.stage]) return;
    ev('diamond_guided_canary', { props: {
      experiment: row.experiment,
      experiment_name: String(row.name || "Jacob's Lane").slice(0, 40),
      group: row.group,
      stage: row.stage,
      shape: String(row.shape || '').slice(0, 40),
      carat_range: String(row.carat_range || '').slice(0, 40),
      choice: String(row.choice || '').slice(0, 40),
      sku: String(row.sku || '').slice(0, 80)
    }});
    flush();
  }
  window.Stienhardt = window.Stienhardt || {};
  window.Stienhardt.trackDiamondGuidedCanary = sdTrackGuidedCanary;
  var sdGuidedQueued = window.__sdGuidedCanaryQueue || [];
  window.__sdGuidedCanaryQueue = [];
  sdGuidedQueued.forEach(sdTrackGuidedCanary);
  /* diamond-guided-choices-v1-canary: first-party telemetry:end */

  // ---------- share tokens: capture sref arrivals, clean URL ----------
  if (Q.sref && /^[A-Za-z0-9_-]{6,24}$/.test(Q.sref)) {
    ev('share_opened', { props: { token: Q.sref } });
    try {
      var u = new URL(location.href); u.searchParams.delete('sref');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  // ---------- page view ----------
  var sku = null;
  if (PT === 'diamond_pdp') sku = Q.sku || null;
  ev('page_view', { sku: sku });


  // education-assist-v2: bridge and confirmed Calendly lead events.
  var eduSource=Q.edu_source&&/^[a-z0-9-]{1,80}$/.test(Q.edu_source)?Q.edu_source:null;
  var eduModule=Q.edu_module&&/^[a-z0-9_]{1,60}$/.test(Q.edu_module)?Q.edu_module:null;
  var eduAction=Q.edu_action&&/^[a-z0-9_-]{1,24}$/.test(Q.edu_action)?Q.edu_action:null;
  if(eduSource&&eduModule&&eduAction){
    ev('education_bridge_arrived',{props:{source:eduSource,module:eduModule,action:eduAction,destination:location.pathname}});
    if(eduAction==='appointment')ev('appointment_intent',{props:{source:eduSource,module:eduModule,from:location.pathname}});
  }
  var calendlyBooked=false;
  function appointmentKey(){
    try{
      if(window.Stienhardt&&window.Stienhardt.attribution&&window.Stienhardt.attribution.appointmentKey)
        return window.Stienhardt.attribution.appointmentKey();
      var m=document.cookie.match('(?:^|; )_sth_appt_key=([^;]*)');
      return m?decodeURIComponent(m[1]):null;
    }catch(err){return null;}
  }
  window.addEventListener('message',function(e){
    if(e.origin!=='https://calendly.com'||!e.data||e.data.event!=='calendly.event_scheduled'||calendlyBooked)return;
    calendlyBooked=true;
    var props={provider:'calendly',appointment_key:appointmentKey(),source:eduSource,module:eduModule,from:location.pathname};
    ev('appointment_booked',{props:props});flush();
    try{
      if(window.Stienhardt&&window.Stienhardt.attribution&&window.Stienhardt.attribution.markAppointmentBooked){
        window.Stienhardt.attribution.markAppointmentBooked(props);
      }
    }catch(err){}
    if(consentOk()){
      var lead={lead_source:'calendly',lead_id:props.appointment_key||'(consent withheld)',edu_source:eduSource||'(none)',edu_module:eduModule||'(none)'};
      if(typeof window.gtag==='function')window.gtag('event','generate_lead',lead);
      else if(Array.isArray(window.dataLayer))window.dataLayer.push(Object.assign({event:'generate_lead'},lead));
    }
  });

  // ---------- clicks (delegation, allowlist) ----------
  var TRACKED = [
    ['#choosethissetting', 'bld_choose_setting'],
    ['#addtoring', 'bld_add_to_ring'],
    ['#createproduct', 'bld_buy_loose'],
    ['#addToCart', 'bld_add_to_cart_click'],
    ['#directadtocart', 'atc_direct_click'],
    ['a.sd-card', 'diamond_card_click'],
    ['#sp-hint-send', 'share_hint_send'],
    ['#sp-hint-copy', 'share_hint_copy'],
    ['#sd-widen-btn', 'filter_widen'],
    ['#sd-reset', 'filter_reset'],
    ['#sd-mfilter-btn', 'filter_drawer_open'],
    ['.stien-education-bridge a', 'education_bridge_click'],
    ['a[href*="/pages/book-an-appointment"], a[href*="calendly.com"]', 'appointment_intent'],
    ['a[href^="tel:"]', 'call_intent'],
    ['button[name="checkout"], a[href^="/checkout"]', 'checkout_click'],
    ['.sw-wl-btn, [data-sw-wl-btn], [class*="wishlist" i][class*="btn" i], [data-wishlist]', 'wishlist_add'],
    ['a[href*="igi.org" i], a[href*="gia.edu" i], a[href*="certificate" i], [class*="cert" i] a', 'cert_link_click'],
    ['[class*="affirm" i], [href*="affirm" i]', 'affirm_click'],
    ['[class*="chat" i], [aria-label*="chat" i], [id*="chat" i]', 'chat_opened']
  ];
  function cssPath(el) {
    var parts = [], n = el, i = 0;
    while (n && n.nodeType === 1 && i < 4) {
      var s = n.tagName.toLowerCase();
      if (n.id) { parts.unshift(s + '#' + n.id); break; }
      if (n.className && typeof n.className === 'string') {
        var c = n.className.trim().split(/\s+/)[0];
        if (c) s += '.' + c;
      }
      parts.unshift(s); n = n.parentElement; i++;
    }
    return parts.join('>').slice(0, 250);
  }
  var lastClicks = [];
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el) return;
    // rage detection
    var now = Date.now();
    lastClicks.push({ t: now, x: e.clientX, y: e.clientY });
    if (lastClicks.length > 3) lastClicks.shift();
    if (lastClicks.length === 3 && now - lastClicks[0].t < 700 &&
        Math.abs(lastClicks[0].x - e.clientX) < 24 && Math.abs(lastClicks[0].y - e.clientY) < 24) {
      ev('rage_click', { props: { target_path: cssPath(el.closest('a,button') || el) } });
      lastClicks = [];
    }
    // allowlist
    for (var i = 0; i < TRACKED.length; i++) {
      var hit = el.closest(TRACKED[i][0]);
      if (hit) {
        // v3.1: click detail must live under .props — the collector drops
        // unknown top-level fields, which silently emptied EVERY click event
        var extra = { props: {
          target_path: cssPath(hit),
          target_text: (hit.textContent || '').trim().slice(0, 80),
          target_x: window.innerWidth ? Math.round(1000 * e.clientX / window.innerWidth) / 1000 : null,
          target_y: window.innerHeight ? Math.round(1000 * e.clientY / window.innerHeight) / 1000 : null
        } };
        if (TRACKED[i][1] === 'diamond_card_click') {
          var m = (hit.getAttribute('href') || '').match(/sku=([^&]+)/);
          if (m) extra.sku = decodeURIComponent(m[1]);
        }
        // P1: builder actions on a diamond page carry the stone's sku
        if ((TRACKED[i][1] === 'bld_add_to_ring' || TRACKED[i][1] === 'bld_buy_loose') && PT === 'diamond_pdp' && Q.sku) {
          extra.sku = Q.sku;
        }
        // v3.0: entry path is decided by the FIRST COMMIT (choose-setting vs
        // add-to-ring), not by rooms — nested setting pages aren't builder
        // rooms, so room-inference mislabeled setting-first shoppers for weeks.
        // The commit stamp overrides any earlier room guess, once.
        if (TRACKED[i][1] === 'bld_choose_setting' || TRACKED[i][1] === 'bld_add_to_ring' || TRACKED[i][1] === 'bld_buy_loose') {
          try {
            if (!SS.getItem('spj_bentry_c')) {
              var entc = TRACKED[i][1] === 'bld_choose_setting' ? 'setting_first' : 'diamond_first';
              SS.setItem('spj_bentry_c', entc);
              SS.setItem('spj_bentry', entc);
            }
            extra.props.entry = SS.getItem('spj_bentry_c');
          } catch (err2) {}
        }
        // once-per-page dedupe for passive-ish signals
        if (TRACKED[i][1] === 'wishlist_add' || TRACKED[i][1] === 'chat_opened' || TRACKED[i][1] === 'affirm_click') {
          var onceKey = '__spj_once_' + TRACKED[i][1];
          if (window[onceKey]) return;
          window[onceKey] = true;
          if (PT === 'diamond_pdp' && Q.sku) extra.sku = Q.sku;
        }
        if (TRACKED[i][1] === 'share_hint_copy' || TRACKED[i][1] === 'share_hint_send') {
          var tok = 'sh' + (function () {
            try { var a = new Uint8Array(10); crypto.getRandomValues(a); return Array.prototype.map.call(a, function (b) { return (b % 36).toString(36); }).join(''); }
            catch (e0) { return Date.now().toString(36) + Math.floor(Math.random() * 1e6).toString(36); }
          })();
          extra.props = { token: tok, channel: TRACKED[i][1] === 'share_hint_send' ? 'hint_email' : 'copy_link', handle: location.pathname.split('/')[2] || null };
          if (TRACKED[i][1] === 'share_hint_send') {
            var toEl = document.getElementById('sp-hint-to');
            if (toEl && toEl.value) extra.props.remail = String(toEl.value).trim().toLowerCase().slice(0, 120);
          }
          ev('share_created', extra);
          flush();
          // v2.8: the modal copies a CLEAN url — replace it with the tagged
          // link. WebKit only allows clipboard writes started INSIDE the
          // gesture, so use a promise-backed ClipboardItem (starts now,
          // commits after the modal's own copy has landed). Plain-writeText
          // fallback covers Chrome/Android. URL is rebuilt from a whitelist —
          // never forward the sharer's utm/click-id/_kx params to a recipient.
          if (TRACKED[i][1] === 'share_hint_copy' && navigator.clipboard) {
            try {
              var su = new URL(location.origin + location.pathname);
              var keep = ['view', 'sku', 'variant'];
              for (var ki = 0; ki < keep.length; ki++) {
                if (Q[keep[ki]]) su.searchParams.set(keep[ki], Q[keep[ki]]);
              }
              su.searchParams.set('sref', tok);
              var tagged = su.toString();
              var committed = new Promise(function (res) {
                setTimeout(function () { res(new Blob([tagged], { type: 'text/plain' })); }, 300);
              });
              if (window.ClipboardItem && navigator.clipboard.write) {
                navigator.clipboard.write([new ClipboardItem({ 'text/plain': committed })])
                  .catch(function () { ev('share_token_copy_failed', { props: { token: tok } }); });
              } else {
                setTimeout(function () {
                  navigator.clipboard.writeText(tagged)
                    .catch(function () { ev('share_token_copy_failed', { props: { token: tok } }); });
                }, 300);
              }
            } catch (e3) {}
          }
          return;
        }
        ev(TRACKED[i][1], extra);
        if (/add_to_cart|atc|checkout/.test(TRACKED[i][1])) flush();
        return;
      }
    }
    // generic nav clicks on internal links from tracked containers
    var a = el.closest('header a, nav a, a[href^="/products/"], a[href^="/collections/"]');
    if (a) ev('nav_click', { props: { target_path: cssPath(a), target_text: (a.textContent || '').trim().slice(0, 80) } });
  }, { capture: true, passive: true });

  // ---------- filters (diamond search + collection facets) ----------
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.id) {
      var f = el && el.closest ? el.closest('form[action*="/collections/"]') : null;
      if (f) ev('filter_applied', { props: { group: 'collection_facet' } });
      return;
    }
    if (/^sd-/.test(el.id)) {
      var group = el.id.replace(/^sd-/, '').replace(/-(min|max|btn|num|disp|fill)$/g, '');
      ev('filter_applied', { props: { group: group } });
    }
  }, { capture: true, passive: true });

  // ---------- scroll depth ----------
  var marks = [25, 50, 75, 90], seen = {};
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var h = document.documentElement;
      var pct = Math.round((h.scrollTop + window.innerHeight) / h.scrollHeight * 100);
      for (var i = 0; i < marks.length; i++) {
        if (pct >= marks[i] && !seen[marks[i]]) {
          seen[marks[i]] = 1;
          ev('scroll_depth', { scroll_pct: marks[i] });
        }
      }
    });
  }, { passive: true });

  // ---------- dwell (visibility-aware) ----------
  var dwellStart = Date.now(), dwellAcc = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { dwellAcc += Date.now() - dwellStart; }
    else { dwellStart = Date.now(); }
  });
  window.addEventListener('pagehide', function () {
    var d = dwellAcc + (document.hidden ? 0 : Date.now() - dwellStart);
    ev('page_dwell', { dwell_ms: d });
    flush();
  });

  // ---------- cart add interception (outside-observer, mirrors funnel tracker) ----------
  try {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?/.test(url)) {
        var resolveAtc = function (ok, status, readd) {
          if (window.__spjAtcResolve && window.__spjAtcResolve(ok, status, readd)) return;
          ev(ok ? 'atc_direct' : (readd ? 'atc_readd' : 'add_to_cart_failed'), { props: { status: status } });
          flush();
        };
        p.then(function (res) {
          var ok = !!(res && res.ok);
          if (ok || !res || res.status !== 422) { resolveAtc(ok, res ? res.status : 0, false); return; }
          // 422: read the body to tell a real failure from the benign re-add —
          // inventory-1 items already in the cart 422 "maximum quantity … already
          // in your cart" and the engine silently redirects to /cart (not an error).
          res.clone().text().then(function (t) {
            resolveAtc(false, 422, /maximum quantity|already in your cart/i.test(t || ''));
          }).catch(function () { resolveAtc(false, 422, false); });
        }).catch(function () {
          resolveAtc(false, -1, false);
        });
      }
      return p;
    };
  } catch (e) {}

  // ---------- cart token (async, attaches to later events) ----------
  if (PT === 'cart' || PT === 'final_ring') {
    try {
      _fetchCart();
    } catch (e) {}
  }
  function _fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.token) {
        ev('cart_viewed', { cart_token: String(c.token).slice(0, 64), props: { items: c.item_count, value_cents: c.total_price } });
      }
    }).catch(function () {});
  }

  // ---------- P2 micro-instrumentation: size, media, video ----------
  var sizeOpened = false;
  function sizeOpen(e) {
    var el = e.target;
    if (!el || !el.matches || sizeOpened) return;
    // v3.1: custom size pickers never focus the underlying select — cover
    // mousedown/click on the select, its label, and size-picker wrappers too
    if (el.matches('select[name*="size" i], select[id*="size" i], label[for*="size" i], [class*="size-select" i], [data-size-select]') ||
        (el.closest && el.closest('[id*="ring-size" i], [class*="ring-size" i]'))) {
      sizeOpened = true;
      ev('size_opened', {});
    }
  }
  document.addEventListener('focusin', sizeOpen, { capture: true, passive: true });
  document.addEventListener('mousedown', sizeOpen, { capture: true, passive: true });
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches) return;
    if (el.matches('select[name*="size" i], select[id*="size" i]') && el.value) {
      ev('size_selected', { props: { size: String(el.value).slice(0, 12) } });
    } else if (el.matches('select[name^="options" i], input[name^="options" i], [name^="properties" i]') && el.value) {
      ev('variant_selected', { props: { value: String(el.value).slice(0, 40) } });
    }
  }, { capture: true, passive: true });

  var mediaKinds = {};
  function mediaTouch(e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el) return;
    var kind = null;
    if (el.closest('[class*="gem360" i], iframe[src*="gem360" i], [class*="v360" i]')) kind = 'gem360';
    else if (el.closest('.swiper-slide, .product__media, [class*="gallery" i], [class*="product-single__photo" i]')) kind = 'gallery';
    if (kind && !mediaKinds[kind] && (PT === 'diamond_pdp' || PT === 'setting_pdp' || PT === 'jewelry_pdp' || PT === 'final_ring')) {
      mediaKinds[kind] = true;
      ev('pdp_media_engaged', { sku: PT === 'diamond_pdp' ? (Q.sku || null) : null, props: { kind: kind } });
    }
  }
  document.addEventListener('click', mediaTouch, { capture: true, passive: true });
  document.addEventListener('touchstart', mediaTouch, { capture: true, passive: true });
  var videoPlayed = false;
  document.addEventListener('play', function () {
    if (videoPlayed) return;
    videoPlayed = true;
    ev('video_play', {});
  }, true);

  // ---------- email identity capture ----------
  // Fires when the shopper hands us their email themselves: newsletter footer,
  // the 50OFF / Klaviyo popup, appointment form, contact form. First email wins
  // server-side; this just reports the moment of capture.
  function capEmail(email, formName) {
    email = String(email || '').trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) return;
    ev('email_captured', { props: { email: email, form: String(formName || 'form').slice(0, 40) } });
    flush();
  }
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (!f || !f.querySelector) return;
      var inp = f.querySelector('input[type="email"], input[name*="email" i]');
      if (inp && inp.value) capEmail(inp.value, f.id || f.getAttribute('action') || 'form');
    } catch (err) {}
  }, { capture: true, passive: true });
  window.addEventListener('klaviyoForms', function (e) {
    try {
      if (!e.detail || e.detail.type !== 'submit') return;
      var inp = document.querySelector('.klaviyo-form input[type="email"], form[data-testid*="klaviyo" i] input[type="email"]');
      if (inp && inp.value) capEmail(inp.value, 'klaviyo:' + (e.detail.formId || 'popup'));
    } catch (err) {}
  });

  // ---------- js errors (first-party scripts only, redacted) ----------
  window.addEventListener('error', function (e) {
    var src = e.filename || '';
    if (!/stienhardt|\/cdn\/shop\//.test(src)) return;
    var msg = String(e.message || '').replace(/[?&](email|token|key|sku)=[^&\s]+/gi, '').slice(0, 120);
    ev('js_error', { props: { msg: msg, src: src.split('/').pop().split('?')[0], line: e.lineno || 0, col: e.colno || 0 } });
  });

  /* ==========================================================
   * REPLAY LOADER — money-path sessions only. The recorder
   * (sp-replay.js ≈ rrweb) downloads ONLY when a session touches
   * builder/cart rooms; ~92% of visitors never fetch a byte of it.
   * ========================================================== */
  try {
    var MONEY = ['setting_pdp', 'diamond_search', 'diamond_pdp', 'final_ring', 'cart'];
    var recOn = false;
    try { recOn = SS.getItem('spj_rec') === '1'; } catch (e) {}
    if (consentOk() && !window.SPJ_NOREPLAY && (recOn || MONEY.indexOf(PT) !== -1)) {
      try { SS.setItem('spj_rec', '1'); } catch (e) {}
      window.__spjIds = { v: visitor, s: session, pt: PT };
      var meTag = document.querySelector('script[src*="sp-track"]');
      if (meTag && meTag.src && meTag.src.indexOf('sp-track.js') !== -1) {
        var repTag = document.createElement('script');
        repTag.src = meTag.src.split('sp-track.js')[0] + 'sp-replay.js';
        repTag.defer = true;
        document.head.appendChild(repTag);
      }
    }
  } catch (e) {}

  /* ==========================================================
   * BUILDER MODULE v2 — native rebuild of the funnel tracker.
   * Detection logic inherited from sp-funnel-clarity (watchdog
   * timings, silent-fail catch, double-count guard); data model
   * rebuilt for rich events instead of Clarity's flat names.
   * ========================================================== */
  var BLD = ['setting_pdp', 'diamond_search', 'diamond_pdp', 'final_ring'];
  var isBld = BLD.indexOf(PT) !== -1;

  // entry-order: first builder room this session decides diamond_first vs setting_first
  var entry = null;
  try {
    entry = SS.getItem('spj_bentry');
    if (!entry && isBld) {
      entry = (PT === 'diamond_search' || PT === 'diamond_pdp') ? 'diamond_first' : 'setting_first';
      SS.setItem('spj_bentry', entry);
    }
  } catch (e) {}
  function bprops(extra) {
    var p = { entry: entry || 'other' };
    if (sku) p.sku = sku;
    var d = (location.search.match(/[?&]diamond=([^&]+)/) || [])[1];
    if (d) p.diamond = decodeURIComponent(d).slice(0, 64);
    if (extra) for (var k in extra) p[k] = extra[k];
    return p;
  }

  if (isBld) {
    try { SS.setItem('spj_bld', '1'); } catch (e) {}
    // step event with context (replaces bld_step1/2/3 flat names)
    var STEP = { setting_pdp: 1, diamond_search: 2, diamond_pdp: 2, final_ring: 3 };
    ev('bld_step', { props: bprops({ step: STEP[PT], room: PT }) });

    // leak watchdogs — 8s, the timing the old tracker earned the hard way
    setTimeout(function () {
      try {
        if (PT === 'diamond_pdp' && !document.getElementById('addtoring')) {
          ev('bld_leak', { props: bprops({ kind: 'diamond_pdp_blank' }) }); flush();
        }
        if (PT === 'final_ring') {
          if (!/[?&]diamond=/.test(location.search)) {
            ev('bld_leak', { props: bprops({ kind: 'no_diamond_param' }) }); flush();
          } else if (!document.getElementById('addToCart')) {
            ev('bld_leak', { props: bprops({ kind: 'final_ring_blank' }) }); flush();
          }
        }
        if (PT === 'diamond_search') {
          var grid = document.getElementById('sd-grid');
          if (grid && !grid.querySelector('.sd-card') && !document.getElementById('sd-end')) {
            ev('bld_leak', { props: bprops({ kind: 'diamond_catalog_empty' }) }); flush();
          }
        }
      } catch (e) {}
    }, 8000);
  }

  // add-to-cart truth: click arms a watchdog; fetch intercept resolves it.
  // shared flag prevents the slow-Supabase double-count (the June lesson).
  var atcPending = null;
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('#addToCart, #addtoring') : null;
    if (!el) return;
    if (el.id === 'addtoring' && document.cookie.indexOf('_ring') === -1) {
      ev('bld_leak', { props: bprops({ kind: 'add_to_ring_no_setting' }) }); flush();
    }
    if (el.id === 'addToCart') {
      var sizeSel = document.querySelector('select[name*="size" i], select[id*="size" i]');
      if (sizeSel && !sizeSel.value) {
        ev('bld_leak', { props: bprops({ kind: 'size_blocked' }) }); flush();
        return;
      }
      atcPending = Date.now();
      setTimeout(function () {
        if (atcPending) {
          atcPending = null;
          ev('bld_leak', { props: bprops({ kind: 'atc_silent_fail' }) }); flush();
        }
      }, 8000);
    }
  }, { capture: true, passive: true });

  // resolve pending in the existing fetch intercept path via a custom hook
  window.__spjAtcResolve = function (ok, status, readd) {
    if (PT !== 'final_ring') return false;
    var was = atcPending; atcPending = null;
    // readd = 422 "already in your cart": the ring IS in the cart and the engine
    // redirects there — log it as its own event, never as a failure (8/5 finding:
    // ALL 39 "failures" 7/30-8/5 were this flavor; true fail rate was 0).
    ev(ok ? 'bld_add_to_cart_success' : (readd ? 'bld_atc_readd' : 'bld_add_to_cart_failed'),
      { props: bprops({ status: status, waited_ms: was ? Date.now() - was : null }) });
    flush();
    return true; // tells generic path to skip atc_direct
  };

  // cart-room behavior (only meaningful if this session touched the builder)
  if (PT === 'cart') {
    var touched = false;
    try { touched = SS.getItem('spj_bld') === '1'; } catch (e) {}
    if (touched) ev('bld_cart_reached', { props: bprops() });
    var checkedOut = false;
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href^="/checkout"]')) checkedOut = true;
    }, { capture: true, passive: true });
    var cartStart = Date.now();
    window.addEventListener('pagehide', function () {
      if (touched && !checkedOut && Date.now() - cartStart > 10000) {
        ev('bld_cart_abandoned', { props: bprops({ dwell_ms: Date.now() - cartStart }) });
        flush();
      }
    });
    try {
      var _f2 = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = _f2.apply(this, arguments);
        if (/\/cart\/(change|update)(\.js)?/.test(url)) {
          p.then(function () { ev('bld_cart_changed', { props: bprops() }); }).catch(function () {});
        }
        return p;
      };
    } catch (e) {}
  }
})();
